import React, { useState, useEffect } from "react";
import "./Flashcard.css";


const Flashcard = ({ question, answer, direction, cardNumber }) => {
  const [flipped, setFlipped] = useState(false);
console.log("cardNumber =", cardNumber);

  // 🔥 Reset flip when question changes
  useEffect(() => {
    setFlipped(false);
  }, [question]);

  return (
    <div className={`card-slide ${direction}`}>
      <div className={`card ${flipped ? "flipped" : ""}`}>
        <div className="card-inner">

          <div className="card-front">
           <h1
              className="question-title"
              style={{ whiteSpace: "pre-line" }}
            >
            ({cardNumber}) {question}
            </h1>  
            <button onClick={() => setFlipped(true)}>
              Show Answer
            </button>
          </div>

    <div className="card-back">


<div
  style={{
    flex: 1,
    width: "100%",
    display: "flex",
    justifyContent: (answer || "").length > 300 ? "flex-start" : "center",
    alignItems: (answer || "").length > 300 ? "flex-start" : "center",
    overflowY: "auto",
  }}
>
  <div
    style={{
      width: "100%",
      whiteSpace: "pre-line",
      wordBreak: "break-word",
      lineHeight: "1.5",
      fontSize: "1.5rem",
      fontWeight: "bold",
      textAlign: "left",
      marginTop: "30px",
      marginBottom: "30px",
      marginRight: "30px",
      marginLeft: "30px"
    }}
  >
    {answer}
  </div>
</div>
            <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: "25px",
  }}
>
  <button onClick={() => setFlipped(false)}>
    Back
  </button>
</div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Flashcard;